import { UserRequest } from "@/api/UsersService"
import { UserFormData } from "@/pages/Settings/Users/types"

export const formatUserData = (userData: UserFormData): UserRequest => {
   return {
      firstName: userData.firstName,
      lastName: userData.lastName,
      phone: { prefix: "", number: userData.phoneNumber },
      email: userData.email,
      role: userData.role,
   }
}
